import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
import { RatersService } from '../raters/raters.service';
import { HelpersService } from '../helpers/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class QuickInsightsService {

    constructor(public _utilsService: UtilsService, public _raters: RatersService, public _helper: HelpersService) { }

    getComparisonV2Data(query_object: any) {
        const url = this._utilsService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.comparisonV2Data);
        return this._utilsService.postAPICall(url, query_object, this._utilsService.setHeaders())
    }
    getLeaderboardSummary(query_object: any) {
        const url = this._utilsService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.postLeaderboardSummary);
        return this._utilsService.postAPICall(url, query_object, this._utilsService.setHeaders())
    }
    getHierarchyLevelList() {
        var brandDetails = Helpers.getBrandDetails();
        var hierarchyMap = this.getHierarchyLevelMapping(brandDetails);
        if (Helpers.hasProperty(brandDetails, 'leaderboard_computation_config.hierarchy.display_level_list')) {
        var hierarchyMapByConfig = {};
        var levels = brandDetails.leaderboard_computation_config.hierarchy.display_level_list;
        for (var idx in levels) {
            var level = levels[idx];
            if (level in hierarchyMap) {
                hierarchyMapByConfig[level] = hierarchyMap[level];
            }
        }
        return hierarchyMapByConfig;
        } else {
            return hierarchyMap;
        }
    }

    getHierarchyLevelMapping(brandDetails) {
        var hierarchyMap = {};
        if (brandDetails.hierarchy_list) {
            var keys = Object.keys(brandDetails.hierarchy_list);
            for (var idx in keys) {
                var key = keys[idx];
                var hierarchy_list = brandDetails.hierarchy_list[key];
                var hierarchy_list_alias = brandDetails.hierarchy_list_alias[key].values;
                if (hierarchy_list && hierarchy_list_alias) {
                    for (var h_idx in hierarchy_list) {
                        var h_key = hierarchy_list[h_idx];
                        var h_value = hierarchy_list_alias[h_idx];
                        hierarchyMap[h_value] = {
                            name: h_key,
                            value: h_value
                        }
                    }
                }
            }
        }
        return hierarchyMap;
    }

    getExportedData(data, raterType) {
        if (!data || !raterType) {
        return null;
        }
        var column = [{
            'display_name': 'Name',
            'field_name': 'name',
            'order': 1
        }, {
            'display_name': 'Score',
            'field_name': 'score',
            'order': 2
        }, {
            'display_name': 'Responses',
            'field_name': 'number_of_users_rated_primary_rating',
            'order': 3
        }, {
            'display_name': 'Quartile',
            'field_name': 'quartile',
            'order': 4
        }];
        var raterDetails = this._raters.getRaterDetails(raterType);
        if (raterDetails && raterDetails.distributions) {
        var field: any = {};
        for (var idx in raterDetails.distributions) {
            field = {
                'display_name': raterDetails.distributions[idx].label,
                'field_name': raterDetails.distributions[idx].field_id,
                'order': 5
            }
            column.push(field)
        }
        for (var idx in raterDetails.distributions) {
            field = {
                'display_name': raterDetails.distributions[idx].label + ' %',
                'field_name': raterDetails.distributions[idx].field_id + '_per',
                'order': 6
            }
            column.push(field)
        }
        }
        for (var d_idx = 0; d_idx < data.length; d_idx++) {
        data[d_idx].score = raterType == 3 ? parseInt((data[d_idx].net_promoter_score).toFixed(0)) : parseInt((data[d_idx].average_rating).toFixed(1));
        if (raterDetails && raterDetails.distributions) {
            for (var idx in raterDetails.distributions) {
                var field_id = raterDetails.distributions[idx].field_id;
                if (data[d_idx][field_id] != undefined && data[d_idx].number_of_users_rated_primary_rating) {
                    data[d_idx][field_id + '_per'] = ((data[d_idx][field_id] * 100) / data[d_idx].number_of_users_rated_primary_rating).toFixed(1);
                } else {
                    data[d_idx][field_id + '_per'] = 'N/A';
                }
            }
        }
        }
        return {
            'columns': column,
            'data': data
        }
    }

    processResponse(responses, raterType, topPerformerLevel?){
        try {
            if (responses && raterType) {
                var options = {
                    'distributionType': 'percentage',
                    'showPercentage': true
                }
                var raterDetails = this._raters.getRaterDetails(raterType);
                for (var idx in responses) {
                    responses[idx] =  this.processResponseBasedOnRater(responses[idx], raterType, topPerformerLevel);
                    responses[idx].positives = responses[idx].number_of_positive_rating;
                    responses[idx].negatives = responses[idx].number_of_negative_rating;
                    responses[idx].number_of_users_rated = responses[idx].total_response;
                    responses[idx].distribution = this.getDistribution(responses[idx], raterType, options);
                    if (raterDetails && raterDetails.distributions) {
                        responses[idx] = this.getPercentageDistributionValues(responses[idx], raterDetails.distributions)
                    }
                }
            }
            return responses;
        } catch(e) {
            return responses;
        }
    }

    processResponseBasedOnRater(data, raterType, topPerformerLevel) {
        var response: any = {};
        if (data.current) {
            response = data.current;
        } else {
            response = data;
        }

        if (response.top_performer && topPerformerLevel && response.top_performer[topPerformerLevel]) {
            response.top_performer_name = response.top_performer[topPerformerLevel].name;
            if (raterType == 3) {
                if (response.top_performer[topPerformerLevel].net_promoter_score) {
                    response.top_performer_nps = parseFloat(response.top_performer[topPerformerLevel].net_promoter_score.toFixed(0));
                } else {
                    response.top_performer_nps = 0;
                }
            } else {
                if (response.top_performer[topPerformerLevel].average_rating) {
                    response.top_performer_avg = parseFloat(response.top_performer[topPerformerLevel].average_rating.toFixed(1));
                } else {
                    response.top_performer_avg = 0;
                }
            }
        }
        if (raterType == 3) {
            response.net_promoter_score = Helpers.getNps({
                'promoters': response.promoters,
                'detractors': response.detractors,
            }, response.number_of_users_rated_primary_rating);
            if (response.net_promoter_score) {
                response.net_promoter_score = parseFloat(response.net_promoter_score.toFixed(0))
            } else {
                response.net_promoter_score = 0;
            }
        } else {
            response.average_rating = parseFloat(response.average_rating.toFixed(1));
        }

        if (data.previous) {
            response.previous = data.previous;
            response.deviations = {};
            response.deviations.number_of_users_rated_primary_rating = Helpers.getFieldDeviation(response.number_of_users_rated_primary_rating, response.previous.number_of_users_rated_primary_rating);
            if (raterType == 3) {
                response.previous.net_promoter_score = Helpers.getNps({
                    'promoters': response.previous.promoters,
                    'detractors': response.previous.detractors,
                },response.previous.number_of_users_rated_primary_rating);
                if (response.previous.net_promoter_score) {
                    response.previous.net_promoter_score = parseFloat(response.previous.net_promoter_score.toFixed(0));
                } else {
                    response.previous.net_promoter_score = 0;
                }
                response.deviations.net_promoter_score = Helpers.getFieldDeviation(response.net_promoter_score, response.previous.net_promoter_score);
            } else {
                response.previous.average_rating = parseFloat(response.previous.average_rating.toFixed(1));
                response.deviations.average_rating = Helpers.getFieldDeviation(response.average_rating, response.previous.average_rating);
            }
        }
        if (!response.number_of_users_rated_primary_rating) {
            if (raterType == 3) {
                response.net_promoter_score = 'N/A';
            } else {
                response.average_rating = 'N/A';
            }
        }
        return response;
    }

    getPercentageDistributionValues(data, distribution) {
        if (data && distribution && distribution.length) {
            for (var idx in distribution) {
                var field_id = distribution[idx].field_id;
                if (data[field_id] != undefined && data.number_of_users_rated_primary_rating) {
                    data[field_id + '_per'] = ((data[field_id] * 100) / data.number_of_users_rated_primary_rating).toFixed(1);
                    data[field_id + '_per_color'] = distribution[idx].color;
                    data['quickInsightsId'] = 'id_quickInsights';
                } else {
                    data[field_id + '_per'] = 'N/A';
                }
            }
        }
        return data;
    }

    getDistribution(data, raterType, options) {
        var distribution: any = {};
        distribution.options = options;
        distribution.raterType = "distribution";
        var distributedValues: any = [];

        var raterDetails = this._raters.getRaterDetails(raterType);
        if (raterDetails && raterDetails.distributions) {
            distributedValues = raterDetails.distributions;
            for (var idx in distributedValues) {
                var fieldId = distributedValues[idx].field_id;
                if (data[fieldId]) {
                    distributedValues[idx].rated = data[fieldId];
                } else {
                    distributedValues[idx].rated = 0;
                }
            }
        }
    
        // Set distribution values which is process before
        distribution.value = distributedValues;
        return distribution;
    }
}
